import { render } from "./BannerSetting.vue?vue&type=template&id=0d4175ba"
import script from "./BannerSetting.vue?vue&type=script&lang=js"
export * from "./BannerSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/miniProgram/setting/component/BannerSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d4175ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d4175ba', __exports__)) {
    api.reload('0d4175ba', __exports__)
  }
  
  module.hot.accept("./BannerSetting.vue?vue&type=template&id=0d4175ba", () => {
    api.rerender('0d4175ba', render)
  })

}


export default __exports__